import { useContext } from "react";
import { StateContext } from "../Board/StateContext";

export function useSecret() {
  return useContext(StateContext).secret;
}
